import { AlertTriangle, PartyPopper } from "lucide-react";

export const isBirthdayMonth = (birthDate) => {
  if (!birthDate || birthDate.length < 7) return false;
  return parseInt(birthDate.slice(5, 7), 10) === new Date().getMonth() + 1;
};

export default function UserAvatar({ name = "", photo, pendencia = false, termo = false, birthDate = null, size = "md", testid }) {
  const dims = size === "lg" ? "w-24 h-24 text-2xl" : size === "sm" ? "w-9 h-9 text-xs" : "w-12 h-12 text-sm";
  const initials = name.split(" ").filter(Boolean).map((p) => p[0]).slice(0, 2).join("").toUpperCase() || "?";
  const aniversariante = isBirthdayMonth(birthDate);
  return (
    <div className={`relative shrink-0 ${dims}`} data-testid={testid}>
      <div className="w-full h-full rounded-full overflow-hidden ring-1 ring-gold/40 bg-[#26262e] flex items-center justify-center">
        {photo ? (
          <img src={photo} alt={name} className="w-full h-full object-cover" />
        ) : (
          <span className="font-display font-bold text-gold">{initials}</span>
        )}
      </div>
      {aniversariante && (
        <span
          className="absolute -top-2.5 left-1/2 -translate-x-1/2 -rotate-12"
          title="Aniversariante do mês!"
          data-testid={testid ? `${testid}-aniversario` : "avatar-aniversario"}
        >
          <PartyPopper size={size === "lg" ? 24 : 16} className="text-gold fill-gold/40 drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)]" strokeWidth={2.2} />
        </span>
      )}
      {termo ? (
        <span
          className="absolute -bottom-1 -right-1"
          title="Pendência: termo de responsabilidade não assinado"
          data-testid={testid ? `${testid}-termo` : "avatar-termo"}
        >
          <AlertTriangle size={size === "lg" ? 22 : 16} className="fill-red-500 text-obsidian drop-shadow" strokeWidth={2.5} />
        </span>
      ) : pendencia ? (
        <span
          className="absolute -bottom-1 -right-1"
          title="Pendência: boletim escolar"
          data-testid={testid ? `${testid}-pendencia` : "avatar-pendencia"}
        >
          <AlertTriangle size={size === "lg" ? 22 : 16} className="fill-yellow-400 text-obsidian drop-shadow" strokeWidth={2.5} />
        </span>
      ) : null}
    </div>
  );
}
